import React, { Component } from 'react';
import { GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
import RegExpHelper from '../../../../../../Common/Helpers/RegExpHelper';

class BajaMotivoComentario extends Component {
    constructor(props) {
        super(props)
        this.valorTextArea = this.props.valorTextArea.bind(this);
        this.valorSelect = this.props.valorSelect.bind(this);
        this.changeCheckSolicitarCaidaCuotas = this.props.changeCheckSolicitarCaidaCuotas.bind(this);
    }

    onChangeTextArea(event) {
        let value = event.target.value;
        let respuesta = RegExpHelper.SoloAlfanumericosConEspacios(value);

        if (respuesta || value == "") {
            this.props.valorTextArea(value);
        }
    }

    onChangeMotivosBaja(event) {
        this.props.valorSelect(event.target.value);
    }

    changeCheckSolicitarCaidaCuotas(){
        this.props.changeCheckSolicitarCaidaCuotas();
    }

    render() {
        const { bajaCuentaData, saldoTotal, saldoNoVencido, valorTxtArea, checkSolcitarCaidaCuotas, motivosBaja } = this.props;
        let claseEstado = "modal-news-modifications-button-green-central-rectangle";
        let nombreEstado = bajaCuentaData.bajaCuenta0.DescripcionEstado;
        let saldoActual = bajaCuentaData.bajaCuenta1.SaldoActual;
        let tcAsociadas = bajaCuentaData.bajaCuenta13.CantidadTarjetasCuenta;
        
        let motivosBajaArray = bajaCuentaData.motivosBaja.map(function (motivos) {
            return (<GenericOption id={motivos.ID}
                description={motivos.DESCRIPCION}
                key={"MotBa_" + motivos.ID} />);
        });

        motivosBajaArray.unshift(<GenericOption id={null}
            description={"Seleccione..."}
            selected={"selected"} key={"MotBa_0"} />);

        let checkSolicitarCaidaDeCuotas = true;
        if (saldoNoVencido == 0){
            checkSolicitarCaidaDeCuotas = false;
        }

        return <div className="container-fluid saldos-resumenes">
            <div>

                <div className="col-md-3">
                    <p>Saldo Actual</p>
                    <p>Saldo no Vencido</p>
                    <label>Saldo TOTAL</label>
                </div>

                <div className="col-md-3">
                    <p>$ {saldoActual}</p>
                    <p>$ {saldoNoVencido}</p>
                    <label>$ {saldoTotal}</label>
                </div>

                <div className="col-md-6">

                    <div className={claseEstado}>
                        <label className="modal-news-modifications-label-tipografy-central-rectangle">{nombreEstado}</label>
                    </div>

                    <p><sub>Con {tcAsociadas} T.C. asociadas, las cuales seran dadas de</sub></p>
                    <p><sub>baja con esta gestión.</sub></p>
                </div>
            </div>

            <div>
                <div className="col-md-12">
                    <p><sub>(*) SEUO. Saldo de carácter informativo sujeto a intereses, cargos, comisiones e impuestos aplicables,</sub></p>
                    <p><sub>mientras exista saldo deudor, de acuerdo al contrato contrato de tarjeta de crédito firmado por el cliente</sub></p>
                    <p><sub>y la legislación vigente. En el caso de existir movimientos en moneda extranjera, los mismos son</sub></p>
                    <p><sub>considerados en pesos a cotización del día a los efectos de este cálculo.</sub></p>
                </div>
            </div>

            <div>
                <div className="col-md-6">
                    <p>Motivo de Baja</p>

                    <div className="col-md-10">
                        <GenericSelect id="selMot"
                            className="form-control default-select bottom-separator-xs error"
                            options={motivosBajaArray}
                            onChange={(event) => this.onChangeMotivosBaja(event)} />
                    </div>

                    <div className="col-md-12">
                        <ul className="no-bullets no-padding no-margin">
                            <li className="inlineListItem2 lg-margin">
                                <div className="default-checkbox">
                                    <input id="chkCaidaCuotas" name="chkCaidaCuotas" type="checkbox" disabled={ saldoTotal > 0 ? false : true }
                                        onChange={this.changeCheckSolicitarCaidaCuotas} checked={checkSolcitarCaidaCuotas}
                                        value={checkSolcitarCaidaCuotas} />
                                    <label className="label-primary" htmlFor="chkCaidaCuotas"></label>
                                </div>
                            </li>
                            <li className="inlineListItem2">
                                <label className="label-primary" htmlFor="chkCaidaCuotas">Solicitar caída de cuotas</label>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="col-md-6">
                    <p>Comentario adicionales</p>
                    <textarea maxLength="99" onChange={(event) => this.onChangeTextArea(event)} value={valorTxtArea}> </textarea>
                </div>
            </div>

        </div>
    }
};
export default BajaMotivoComentario;